<template>
  <div class="partnerBenefits text-center my-3">
    <p>
      Global <strong class="blue">Interfacing</strong>
    </p>
    <i class="fas fa-chevron-down my-4 partnerBenefits__arrow"></i>
    <p>
      Transparency of <strong class="blue">Deal Cycle</strong>
    </p>
    <i class="fas fa-chevron-down my-4 partnerBenefits__arrow"></i>
    <p>
      A Forum to <strong class="blue">Gain</strong>
    </p>
    <i class="fas fa-chevron-down my-4 partnerBenefits__arrow"></i>
    <p>
      Opportunity to <strong class="blue">Grow</strong>
    </p>
    <i class="fas fa-chevron-down my-4 partnerBenefits__arrow"></i>
    <p>
      Efficient <strong class="blue">Quote to Cash</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PartnerBenefits',
};
</script>

<style scoped>
.partnerBenefits {
  color: var(--black); 
  font-weight: var(--font-thick);
  font-size: var(--font-bg);
}


.partnerBenefits__arrow {
  color: red;  
  font-size: 3rem;  
  transition: all 2s ease-in-out;
  animation: movement 2s ease-in-out infinite;
}


@keyframes movement {
  from {
    transform: translateY(-20px); 
  }
  to {
    transform: translateY(20px);   
  }
}
</style>
